<script lang="ts">
    import Popover from './popover.svelte'
    import { onDestroy, onMount } from 'svelte'

    export let notify: number = 0

    let alert: string = ''
    const isMobile = screen.width <= 900

    onMount(async () => {
        setTimeout(checkAlert, 5000)
    })

    onDestroy(() => {
        if (timeout) clearTimeout(timeout)
    })

    let timeout = null
    export async function checkAlert(force: boolean) {
        setTimeout(checkAlert, 360000)
        try {
            const result = await window.api.users.companies.getAlert('alert')
            if (result?.value) {
                await evaluateResult(result, force)
            }
        } catch (error) {}
    }

    let showed: boolean = false
    async function evaluateResult(result, force: boolean) {
        if (!result?.value) return
        // retrocompatibility
        if (!result.value.interval) {
            if (showed) return
            showed = true
            alert = result.value
            console.log('alert-popup mobile retrocomp')
            return
        }
        if (!result.value.message) {
            return
        }
        if (isMobile && result.value.device == 'desktop') {
            console.log('alert-popup mobile ignore')
            return
        }
        if (!isMobile && result.value.device == 'mobile') {
            console.log('alert-popup desktop ignore')
            return
        }
        notify = 1
        let lastShow = await window.flags('alert-popup-last', true)
        lastShow = lastShow ? new Date(lastShow) : new Date(0)
        const diffHours = Math.abs(new Date().getTime() - lastShow.getTime()) / 36e5
        if (!force && diffHours < result.value.interval) {
            console.log('alert-popup interval ignore')
            return
        }
        await window.flags('alert-popup-last', true, new Date())
        alert = convertLinks(result.value.message)
    }

    function goClose() {
        alert = ''
    }

    function convertLinks(input: string): string {
        return input.replace(/\((https?:\/\/[^\s)]+)\)/g, (_match, url) => {
            return `<a target="_blank" href="${url}">${url}</a>`
        })
    }
</script>

{#if alert}
    <Popover on:close={() => (alert = '')} width="740px" height="140px">
        <div class="config-box m-4 text-center box-alert">
            <div class="subtitle">Importante:</div>
            <p>{@html alert}</p>
            <!-- <button class="btn btn-primary" on:click={goClose}>Ok</button> -->
        </div>
    </Popover>
{/if}

<style>
    .box-alert .subtitle {
        font-size: 22px;
        margin-bottom: 16px;
    }
    .box-alert p {
        text-align: left;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
    }

    :global(.box-alert a) {
        text-decoration: underline;
    }
</style>
